import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeaders, axiosInstance, logError } from "../../utils/helper";

const initialState = {
  data: [],
  loading: false,
};

export const getCardList = createAsyncThunk(
  "card/getCardList",
  async (params) => {
    const res = await axiosInstance.get("store/list-card", { params, ...authHeaders() });
    const data = await res.data;
    return data;
  }
);

const card = createSlice({
  name: "card",
  initialState,
  reducers: {
    setCard: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearCard: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCardList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCardList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.result;
      })
      .addCase(getCardList.rejected, (state, action) => {
        state.loading = false;
        state.data = [];

        // logError(new Error(action.error?.message), {
        //   feature: "getCardList",
        //   actionType: action.type,
        // });
      });
  },
});

// Export actions and reducer
export const { setCard, clearCard } = card.actions;
export default card.reducer;
